import { AutogenLayoutTableEquipmentAlerts } from "./autogen/AutogenLayoutTableEquipmentAlerts";
import { Component } from "@mcleod/components";

export class TableEquipmentAlerts extends AutogenLayoutTableEquipmentAlerts {
    onLoad(): void | Promise<void> {
        const headingCellPMLevel = this.tableEquipAlerts.tableHeadingRow.cells?.find(cell => cell.caption === "PM Level");
        headingCellPMLevel?.getRecursiveChildren().filter(child => child.tooltip == headingCellPMLevel.caption).forEach((comp: Component) => {
        comp.tooltip = "Priority Maintenance Level";
        });
    }
}
